import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'

export function FireRudderstackImpressionEvent({ rudderstack, children }) {
  const [rudderstackData] = useState(rudderstack)

  useEffect(() => {
    const sampleDiv = typeof document !== 'undefined' && document.createElement('div')

    /* istanbul ignore else */
    if (sampleDiv) {
      Object.keys(rudderstackData).map((k) => sampleDiv.setAttribute(k, rudderstackData[k]))
      const dataset = sampleDiv.dataset
      const eventType = dataset.subType

      if (eventType) {
        const event = eventType.replace(/\s+/, '_')
        //@ts-ignore
        window.rudderanalytics?.track(event, dataset)
      }
    }
  }, [rudderstackData.category])

  return <>{children}</>
}

FireRudderstackImpressionEvent.propTypes = {
  rudderstack: PropTypes.object,
}

export default FireRudderstackImpressionEvent
